export enum State {
  INIT = 'init',

  DONE = 'done',
  ABORT = 'abort',

  COMPANY_NAME = 'company-name',
  CAPITAL_DEPOSIT_CREATE = 'capital-deposit-create',
  UPDATE_COMPANY_NAME = 'update-company-name',
  MANDATE = 'mandate',
  COMPANY_INFORMATION_INTRO = 'company-information-intro',
  EU_BANK_ACCOUNT = 'eu-bank-account',
  COMPANY_COMPLIANCE = 'company-compliance',
  CAPITAL_DEPOSIT_QUESTIONS = 'capital-deposit-questions',
  BENEFICIARIES = 'beneficiaries',
  PERSONAL_INFORMATION_INTRO = 'personal-information-intro',
  VERIFICATION = 'verification',
  AGREEMENT = 'agreement',
  SEND_APPLICATION = 'send-application',
  SUCCESS = 'success',
  CAPITAL_DEPOSIT_NEXT_STEPS = 'capital-deposit-next-steps',
  BENEFICIARIES_DOCS = 'beneficiaries-docs',
  DOWNLOAD_SHINE_MESSAGE_SENT = 'download-shine-message-sent',
}
